import React, { useState } from 'react';
import { Checkbox, Inline, Stack, Text } from '@treatwell/ui';
import { Amenity } from 'js/model/rainbow/venue/AmenityGroup';
import { NamedEntityOutput } from 'js/model/rainbow/NamedEntityOutput';
import { ConditionalWrapper } from 'js/components/Utilities/ConditionalWrapper';
import { ShowMore } from '../ShowMore/ShowMore';
import styles from './AmenityFilter.module.css';

const MAX_INITIALLY_SHOWN = 6;

export const AmenityFilter = ({
  amenities,
  selectedAmenities,
  onChange,
}: {
  amenities: Amenity[];
  selectedAmenities: ReadonlyArray<NamedEntityOutput>;
  onChange: (selectedAmenities: NamedEntityOutput[]) => void;
}) => {
  const [showAllAmenities, setShowAllAmenities] = useState(
    amenities.length <= MAX_INITIALLY_SHOWN
  );
  const amenitiesToShow = amenities.slice(
    0,
    showAllAmenities ? amenities.length : MAX_INITIALLY_SHOWN
  );

  return (
    <ConditionalWrapper
      condition={!showAllAmenities}
      render={(children) => (
        <Stack align="start" space="sm">
          {children}
        </Stack>
      )}
    >
      <Stack className={styles.list} as="ul" space="sm">
        {amenitiesToShow.map((amenity) => {
          const { id: amenityId, name } = amenity;
          const id = `amenity-${amenityId}`;
          const isSelected = selectedAmenities.some(
            (selectedAmenity) => selectedAmenity.id === amenityId
          );

          return (
            <li key={name}>
              <Inline justify="between" space="sm">
                <Text
                  className={styles.label}
                  type="caption"
                  as="label"
                  htmlFor={id}
                >
                  {name}
                </Text>
                <Checkbox
                  id={id}
                  checked={isSelected}
                  onChange={() => {
                    if (isSelected) {
                      onChange(
                        selectedAmenities.filter(
                          (selectedAmenity) => selectedAmenity.id !== amenityId
                        )
                      );
                    } else {
                      onChange([
                        ...selectedAmenities,
                        {
                          id: amenity.id,
                          name: amenity.name,
                        },
                      ]);
                    }
                  }}
                />
              </Inline>
            </li>
          );
        })}
      </Stack>

      {!showAllAmenities && (
        <ShowMore
          onClick={() => {
            setShowAllAmenities(true);
          }}
        />
      )}
    </ConditionalWrapper>
  );
};
